// extracted by mini-css-extract-plugin
export default {"container":"container_I7APw","title":"title_Dh_tc"};